import { isAppsPathname } from "./apps/appsPaths";
import { isHomePathname } from "./home/homePaths";
import { isInboxPathname } from "./inbox/inboxPaths";
import { INBOX_SIDEBAR_WIDTH_STORAGE_KEY } from "./inbox/inboxSidebarWidth";
import { isRegulationPathname } from "./regulation/regulationPaths";
import { isSettingsPathname } from "./settings/settingsPaths";
import {
  THREAD_SIDEBAR_DEFAULT_WIDTH,
  THREAD_SIDEBAR_WIDTH_STORAGE_KEY,
} from "./threadSidebarWidth";

export const APP_SIDEBAR_WIDTHS = {
  inbox: { storageKey: INBOX_SIDEBAR_WIDTH_STORAGE_KEY, defaultWidth: 380 },
  chat: {
    storageKey: THREAD_SIDEBAR_WIDTH_STORAGE_KEY,
    defaultWidth: THREAD_SIDEBAR_DEFAULT_WIDTH,
  },
  settings: { storageKey: "settings_sidebar_width", defaultWidth: 240 },
  governance: { storageKey: "governance_sidebar_width", defaultWidth: 240 },
  // Home and Apps open at Chat's width, so moving between them never resizes the sidebar.
  home: { storageKey: "home_sidebar_width", defaultWidth: THREAD_SIDEBAR_DEFAULT_WIDTH },
  apps: { storageKey: "apps_sidebar_width", defaultWidth: THREAD_SIDEBAR_DEFAULT_WIDTH },
} as const;

export type AppSidebarSection = keyof typeof APP_SIDEBAR_WIDTHS;

export function appSidebarSection(pathname: string): AppSidebarSection {
  if (isInboxPathname(pathname)) return "inbox";
  if (isSettingsPathname(pathname)) return "settings";
  if (isRegulationPathname(pathname)) return "governance";
  if (isAppsPathname(pathname)) return "apps";
  if (isHomePathname(pathname)) return "home";
  return "chat";
}
